import React, { ReactElement, useEffect, useState, createRef, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { Transfer, Modal, Button, Space, ConfigProvider, Select, Form, Radio, Input, List, Typography } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import type { FormInstance } from 'antd/es/form/Form'
import type { TransferDirection } from 'antd/es/transfer'
import type { RadioChangeEvent } from 'antd'
import zhCN from 'antd/es/locale/zh_CN'
import { useTranslation } from 'react-i18next'
import type { Descendant } from 'slate'
import DSlate, { DefaultPlugin } from '@dslate/dslate'
import type { DSlateRef } from '@dslate/core'
import { ConfigProvider as DslateConfigProvider, defaultConfig } from '@dslate/core'
import { handleTrim, serialize } from '@/pages/table2Mana/table2Edit'
import { IAppState } from '@/store/reducers'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import { getUserOrgChart } from '@/services/auth.service'
import type { IUserInfo } from '@/store/models/auth.model'
import type { IWorkgroupObj } from '@/store/models/tableEdit.model'
import { getUserWorkGroup,getOrgRoleUsers } from '@/services/progress.service'
import { RoleCont } from '@/store/constant/auth.constant'
import { getUuid } from '@/utils/util'
import PersonSearch from '@/components/personSearch'

const plugs = { ...DefaultPlugin }
// 删除图片工具
Reflect.deleteProperty(plugs, 'ImgPlugin')

function SelectUser ({
    show,
    setShow,
    confirm,
    title,
    canChangeWorkgroup = true,
    curWorkGroupId,
    enableWorkgroupLs = [],
    isRelevant = false
}: {
    show: boolean
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    setShow: (b: boolean) => void
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    confirm: ({ users, isItmtRelevant, workGroupId }:{users: IUserInfo[], isItmtRelevant?: boolean, workGroupId?: number}) => void
    title: string
    canChangeWorkgroup?: boolean
    curWorkGroupId?: string
    enableWorkgroupLs?: IWorkgroupObj[]
    isRelevant?: boolean
}): ReactElement {
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const location = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const [targetKeys, setTargetKeys] = useState<string[]>([])
    const [selectedKeys, setSelectedKeys] = useState<string[]>([])
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [isModalOpenSearch, setIsModalOpenSearch] = useState(false)
    const [selectWorkgroup, setSelectWorkgroup] = useState<number | null>(null)
    const [userLs, setUserLs] = useState<IUserInfo[]>([])
    const [transferKey, setTransferKey] = useState('1')
    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const [selectedMap, setSelectedMap] = useState<any>({})
    const [selectedList, setSelectedList] = useState<any>({})
    const workgroupList = useSelector((state: IAppState) => state.tableEditData.workgroupList)
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const [winH, setWinH] = useState<number>(0)

    const [editorKey, setEditorKey] = useState('1')
    // 富文本编辑器 内容
    const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    const formRef = createRef<FormInstance>()
    // 富文本编辑器
    const editorRef = useRef<DSlateRef>(null)

    const { Text } = Typography
    const { Option } = Select

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 18 },
    }

    // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    const onChange = (nextTargetKeys: string[], direction: TransferDirection, moveKeys: string[]) => {
        const formObj = formRef.current?.getFieldsValue()
        console.log('formObj.auditOrNot: ', formObj?.auditOrNot)
        if (formObj && formObj.auditOrNot === undefined) {
            formObj.auditOrNot = 1
        }
        setTargetKeys(nextTargetKeys)
        const tmtInfos = userLs.filter((item: IUserInfo) => nextTargetKeys.includes(item.login))
        if (selectWorkgroup) {
            const findWorkgroup = workgroupList.find(item => item.id === selectWorkgroup)
            setSelectedMap({
                ...selectedMap,
                [`workgroup_${selectWorkgroup}`]: {
                    ...selectedMap[`workgroup_${selectWorkgroup}`],
                    auditOrNot: formObj?.auditOrNot === 2 ? true : null,
                    isRelevant: formObj?.auditOrNot === 1 ? true : (formObj?.auditOrNot === 3 ? false : null),
                    tmtInfos: tmtInfos.map((item: IUserInfo) => ({
                        tmtFullUser: item.nickName,
                        tmtMail: item.email,
                        tmtUser: item.login
                    })),
                    workGroupId: selectWorkgroup,
                    workGroupName: findWorkgroup?.groupName,
                    description: descriptionValue
                }
            })
        }
    }
    const onSelectChange = (sourceSelectedKeys: string[], targetSelectedKeys: string[]) => {
        // console.log('sourceSelectedKeys: ', sourceSelectedKeys, targetSelectedKeys)
        setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys])
    }
    const onChangeAuditOrNot = (e: RadioChangeEvent) => {
        const val = e.target.value
        if (selectWorkgroup) {
            const findWorkgroup = workgroupList.find(item => item.id === selectWorkgroup)
            setSelectedMap({
                ...selectedMap,
                [`workgroup_${selectWorkgroup}`]: {
                    ...selectedMap[`workgroup_${selectWorkgroup}`],
                    auditOrNot: val === 2 ? true : null,
                    isRelevant: val === 1 ? true : (val === 3 ? false : null),
                    workGroupId: selectWorkgroup,
                    workGroupName: findWorkgroup?.groupName,
                    description: descriptionValue
                }
            })
        }
    }
    const onConfirm = async () => {
        try {
            let res: any = []
            if (isRelevant) {
                const formObj = formRef.current?.getFieldsValue()
                if (formObj?.auditOrNot === undefined) {
                    formRef.current?.setFieldValue('auditOrNot', 1)
                }
                await formRef.current?.validateFields()
                for (const key in selectedMap) {
                    const val = selectedMap[key]
                    let description: any
                    if (val.description) {
                        description = editorRef.current?.serialize({ children: serialize(handleTrim(val.description)) })
                    }
                    res.push({
                        creatorName: userInfo?.nickName || '',
                        workGroup: {
                            workGroupId: val.workGroupId,
                            workGroupName: val.workGroupName,
                        },
                        isRelevant: val.isRelevant,
                        auditOrNot: val.auditOrNot,
                        tmtInfos: val.tmtInfos,
                        description: description ? JSON.stringify({
                            str: description,
                            obj: val.description
                        }) : ''
                    })
                }
                if (selectWorkgroup) {
                    confirm({ users: res, isItmtRelevant: true, workGroupId: selectWorkgroup })
                }
            } else {
                res = userLs.filter(item => targetKeys.includes(item.login))
                if (selectWorkgroup) {
                    confirm({ users: res, workGroupId: selectWorkgroup })
                }else{
                    confirm({ users: res, workGroupId: 9999 })
                }
            }
            closePop()
        } catch (e) {
            console.log('onConfirm: ', e)
        }
    }
    const closePop = () => {
        setShow(false)
    }

    const onClickSearch = () => {
        setIsModalOpenSearch(true)
    }
    const closePopSearch = () => {
        setIsModalOpenSearch(false)
    }

    const getUserLs = async (id?: number) => {
        try {
            // let str = ''
            // const findObj = workgroupList.find(item => item.id === id)
            // str = findObj?.groupName || ''
            if (!id) {
                // 获取当前登录用户的 workgroup 
                const userInfoRes = await getUserWorkGroup({
                    login: userInfo?.login || '',
                    orgRole: RoleCont.ITMTLEADER
                })
                if (userInfoRes.length > 0) {
                    id = userInfoRes[0].workGroup.id
                }
            }
            if (id) {
                if(id === 9999){
                    // 非PRG和TSP不能选择人
                    const userInfoTsp = await getUserWorkGroup({
                        login: userInfo?.login || '',
                        orgRole: RoleCont.TSP
                    })
                    const userInfoPrg = await getUserWorkGroup({
                        login: userInfo?.login || '',
                        orgRole: RoleCont.PRG
                    })
                    if((userInfoTsp && userInfoTsp.length > 0) || (userInfoPrg && userInfoPrg.length > 0)){
                        // work group不存在的场景：TSP和PRG
                        const tsp = await getOrgRoleUsers({
                            orgRole: RoleCont.TSP
                        })
                        const prg = await getOrgRoleUsers({
                            orgRole: RoleCont.PRG
                        })
                        const res = [ ...tsp,...prg ]
                        const uniRes = Array.from(new Set(res.map((item: { login: any }) => item.login)))
                        const result:IUserInfo[] = []
                        uniRes.forEach(item => {
                            const findObj = res.find((subItem: { login: any }) => subItem.login === item)
                            if (findObj) {
                                result.push(findObj)
                            }
                        })
                        console.log('getUserLs: ', result)
                        setUserLs(result)
                    }
                }else{
                    const res = await getUserOrgChart(id)
                    const uniRes = Array.from(new Set(res.map(item => item.login)))
                    const result:IUserInfo[] = []
                    uniRes.forEach(item => {
                        const findObj = res.find(subItem => subItem.login === item)
                        if (findObj) {
                            result.push(findObj)
                        }
                    })
                    console.log('getUserLs: ', result)
                    setUserLs(result)
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const onFinish = (values: any) => {
        console.log('onFinish: ', values)
    }
    const onFinishFailed = (values: any) => {
        console.log('onFinishFailed: ', values)
    }

    useEffect(() => {
        setWinH(document.body.clientHeight)
        window.onresize = () => {
            setWinH(document.body.clientHeight)
        }
        return () => {
            window.onresize = null
        }
    }, [])
    useEffect(() => {
        if (!canChangeWorkgroup) {
            getUserLs()
        } else if (workgroupList.length > 0) {
            setSelectWorkgroup(workgroupList[0].id)
        }
    }, [workgroupList])
    useEffect(() => {
        setIsModalOpen(show)
        if (show) {
            setEditorKey(getUuid(8))
            setTransferKey(getUuid(8))
            // 父级带过来的选中的 workgroup
            if (curWorkGroupId) {
                setSelectWorkgroup(Number(curWorkGroupId))
            } else if (canChangeWorkgroup && enableWorkgroupLs.length > 0) {
                setSelectWorkgroup(enableWorkgroupLs[0].id)
            }
        }
    }, [show])
    useEffect(() => {
        setSelectedKeys([])
        setTargetKeys([])
        if (selectWorkgroup) {
            getUserLs(selectWorkgroup)
        }
    }, [selectWorkgroup])
    useEffect(() => {
        formRef.current?.setFieldValue('description', 111)
        if (selectWorkgroup) {
            setSelectedMap({
                ...selectedMap,
                [`workgroup_${selectWorkgroup}`]: {
                    ...selectedMap[`workgroup_${selectWorkgroup}`],
                    description: descriptionValue
                }
            })
        }
    }, [descriptionValue])
    useEffect(() => {
        const arr: any[] = []
        for (const key in selectedMap) {
            const val = selectedMap[key]
            arr.push({
                workGroupId: val.workGroupId,
                workGroupName: val.workGroupName,
                tmtInfos: val.tmtInfos?.map((item: any) => item.tmtFullUser) || [],
                auditOrNot: val.isRelevant ? t('join') : 
                    (val.auditOrNot ? t('sitInOn') : 
                        (val.isRelevant === false ? t('isNotRelevant') : '')
                    )
            })
        }
        setSelectedList(arr)
    }, [selectedMap])

    return (<>
        <Modal title={title} open={isModalOpen} 
            onOk={closePop}
            onCancel={closePop}
            width='90%'
            centered
            maskClosable={false}
            footer={[
                <Button key="confirm" type="primary" onClick={onConfirm}>{t('confirm')}</Button>,
                <Button key="close" onClick={closePop}>{t('close')}</Button>
            ]}
        >
            <Space direction='vertical' style={{ width: '100%' }}>
                <Space>
                    {canChangeWorkgroup && <Select placeholder={t('Work Group Placeholder')}
                        style={{ width: 200 }}
                        value={selectWorkgroup}
                        onChange={e => {
                            setSelectWorkgroup(e)
                        }}
                    >
                        {
                            workgroupList.map(item => {
                                return <Option key={item.id} value={item.id}>{item.groupName}</Option>
                            })
                        }
                    </Select>}
                    <Button type='primary' onClick={onClickSearch}>{t('personSearch')}</Button>
                </Space>
                <ConfigProvider locale={i18n.language === 'zh' ? zhCN : undefined}>
                    <Transfer key={transferKey}
                        showSearch
                        style={{ width: '100%' }}
                        listStyle={{ flex: 1, height: 'auto', maxHeight: winH - 250, overflow: 'visible' }}
                        dataSource={userLs}
                        titles={[t('Source'), t('Target')]}
                        rowKey={record => record.login}
                        targetKeys={targetKeys}
                        selectedKeys={selectedKeys}
                        render={item => item.nickName}
                        onSelectChange={onSelectChange}
                        onChange={onChange}
                    />
                </ConfigProvider>
                {isRelevant && (<div style={{ display: 'flex', width: '100%' }}>
                    <Form {...layout} ref={formRef}
                        className='ti_an_detail'
                        style={{ flex: 1, marginRight: 50 }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                    >
                        <Form.Item name='auditOrNot'
                            label={<span className='label'>{t('auditOrNot')}</span>}
                            rules={[
                                {
                                    required: true, message: t('auditOrNot Required')
                                },
                            ]}
                        >
                            <Radio.Group defaultValue={1} onChange={onChangeAuditOrNot}>
                                <Radio value={1}>{t('join')}</Radio>
                                <Radio value={2}>{t('sitInOn')}</Radio>
                                <Radio value={3}>{t('isNotRelevant')}</Radio>
                            </Radio.Group>
                        </Form.Item>
                        <Form.Item name='description'
                            label={<span className='label'>{t('techDetail')}</span>}
                        >
                            <Input hidden />
                            <DslateConfigProvider
                                value={{
                                    ...defaultConfig,
                                    plugins: [
                                        ...Object.values({
                                            ...plugs
                                        }),
                                    ],
                                }}
                            >
                                <DSlate ref={editorRef} key={editorKey} value={descriptionValue} onChange={setDescriptionValue} />
                            </DslateConfigProvider>
                        </Form.Item>
                    </Form>
                    <div style={{ flex: 1 }}>
                        <Space direction='vertical' size={10} style={{ width: '100%' }}>
                            <div style={{ marginTop: 5 }}>{t('your has') + (i18n.language !== 'zh' ? ' ' : '') + t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('list')}：</div>
                            <List style={{ marginBottom: 10, background: '#fff' }}
                                bordered
                                dataSource={selectedList}
                                renderItem={(item: any, index) => <List.Item
                                    key={item.id}
                                    actions={[
                                        <Text className='txt_red hand' onClick={() => {
                                            const workGroupId = selectedList[index].workGroupId
                                            Reflect.deleteProperty(selectedMap, `workgroup_${workGroupId}`)
                                            setSelectedMap({
                                                ...selectedMap
                                            })

                                        }} title={t('delete')}><DeleteOutlined style={{ fontSize: 16 }} /></Text>
                                    ]}
                                >
                                    <Space>{item.workGroupName}: {item.auditOrNot} {item.tmtInfos.join(',')}</Space>
                                </List.Item>}
                            />
                        </Space>
                    </div>
                </div>)}
            </Space>
        </Modal>
        <Modal title={t('personSearch')} open={isModalOpenSearch} 
            width='90%'
            centered
            maskClosable
            footer={null}
            onOk={closePopSearch}
            onCancel={closePopSearch}
        >
            <PersonSearch />
        </Modal>
    </>);
}

export default SelectUser
